import { FC } from "react";

import { Theme } from "apps/website/maps/Theme.map";

import Section from "../../layout/Section/Section";
import Container from "../../layout/Container/Container";
import ImageTagList, {
  IImageTagListProps,
} from "../../feature/ImageTagList/ImageTagList";
import { getSectionSize } from "../../layout/Section/Section.utils";

export interface ISectionImageTagListProps {
  theme: Theme;
  imageTagList: IImageTagListProps;
}

const SectionImageTagList: FC<ISectionImageTagListProps> = ({ theme, imageTagList }) => (
  <Section component={ SectionImageTagList.name } theme={ theme } size={ getSectionSize(theme) }>
    <Container>
      <ImageTagList { ...imageTagList } />
    </Container>
  </Section>
);

export default SectionImageTagList;
